import React from 'react';

type ContextValue = {
  authenticated: boolean;
  roles: string;
  saveAuthenticated: (value: boolean) => void;
  saveRoles: (value: string) => void;
  token: string,
  saveToken: (value: string) => void;
  producer?: object,
}

const AblContext = React.createContext<ContextValue | undefined>(void 0);

export default AblContext;
